function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefreshSwap = function SvgRefreshSwap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14.0416 8.11257C13.8239 10.1579 12.665 12.0747 10.7473 13.1818C7.56118 15.0213 3.4871 13.9297 1.64759 10.7436L1.45167 10.4042M0.791753 6.71285C1.00947 4.66748 2.16839 2.75076 4.08609 1.64358C7.27221 -0.19593 11.3463 0.895715 13.1858 4.08183L13.3817 4.42119M0.750244 12.1667L1.32395 10.0255L3.46506 10.5993M11.3688 4.22617L13.5099 4.79988L14.0836 2.65877",
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export default SvgRefreshSwap;